import intl from 'react-intl-universal';

const DEFAULT_URI = 'ws://127.0.0.1:62022';

export default class WYSocket {
  uri: string;

  connected: boolean;

  socket: WebSocket | null;

  reconnectCount: number;

  reconnectMax: 5;

  constructor(uri?: string) {
    this.uri = uri || DEFAULT_URI;
    this.reconnectCount = 0;
    this.init(uri);
  }

  init(uri?: string) {
    const ws = new WebSocket(uri || DEFAULT_URI);

    // connected
    ws.addEventListener('open', () => {
      this.connected = true;
    });

    this.socket = ws;
    this.failover();
  }

  reconnect() {
    this.init(this.uri);
  }

  failover() {
    // watch connect error, reconnect
    this.socket.addEventListener('error', (err) => {
      if (err) {
        this.connected = false;
        this.socket = null;
        if (this.reconnectCount < this.reconnectMax) {
          this.reconnect();
          this.reconnectCount += 1;
        }
      }
    });
  }

  send(msg: any) {
    if (this.connected) this.socket.send(msg);
  }

  on(callback: Function) {
    if (this.connected) {
      this.socket.onmessage = function (evt) {
        const res = JSON.parse(evt?.data);
        callback(res);
      };
    } else {
      callback({
        code: -1,
        error: intl.get('utils_socket_abort_info'),
      });
    }
  }

  close() {
    this.socket.close();
    this.uri = '';
    this.connected = false;
    this.reconnectCount = 0;
    this.socket = null;
  }
}
